import { actionEsOnMessage } from '@skynet/data-ws-es';
import { describeWsFailure } from 'src/store/utils';
import { registerErrorMessage } from '@skynet/data-ws-core';
import { listen } from '../apiKeys/actions';
import { getEsListenSection } from 'src/store/trading/listen-sections';
import type { TradingBalance, TradingBalancesState } from './types';
import { TradingBalancesCommands } from './types';
import { createBalancesSlice } from 'src/store/shared/balances/factory';

registerErrorMessage(TradingBalancesCommands.Balance, {
  title: 'Balance Error',
  getDescription: describeWsFailure,
});

interface BalanceMessage extends Record<string, unknown> {
  command: string;
  balance: TradingBalance[];
}

function isBalanceMessage(json: Record<string, unknown>): json is BalanceMessage {
  return json.command === TradingBalancesCommands.Balance && Array.isArray(json.balance);
}

const esExtraCommands = Object.values(TradingBalancesCommands);

export const initialState: TradingBalancesState = {
  requestStatus: null,
  error: null,

  balance: [],

  list: {},
  supportedTokens: {},
  selection: [],

  createBalanceSnapshotStatus: null,
  createWalletSnapshotStatus: null,
  addBalanceStatus: null,
  currentProjectId: null,

  balancesCorrection: {
    open: false,
    data: null,
  },
};

const tradingBalancesSlice = createBalancesSlice({
  prefix: 'trading',
  sliceName: 'balances',
  messages: actionEsOnMessage,
  initialState,
  extraCommands: esExtraCommands,
  extraReducers: (builder) => {
    builder.addCase(listen, (state, action) => {
      const { section } = action.payload;
      const { isInitCall } = action.meta;
      if (!section) return;
      // Only the Balances channel. `section` is the wire section, so the `'tasks'`
      // this used to list never matched — the Dashboard listens as `overview` —
      // and matching that instead would re-cover its balances card with a
      // spinner on every visit (SKY-4581).
      if (isInitCall && section === getEsListenSection('balances')) {
        state.requestStatus = 'pending';
      }
    });
  },
  onMessage: (state, json) => {
    // Handle ES-specific Balance command (trading balance list)
    if (isBalanceMessage(json)) {
      state.balance = json.balance;
      state.requestStatus = 'success';
    }
  },
});

export const tradingBalancesActions = tradingBalancesSlice.actions;
export default tradingBalancesSlice.reducer;
